var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.wrapper },
    [
      _c("PageContentImage", {
        class: _vm.imageClass || "w-100",
        attrs: { src: _vm.image }
      }),
      _vm._v(" "),
      _c("PageContent", {
        class: _vm.contentClass || "w-100",
        attrs: {
          title: _vm.content.title,
          paragraphs: _vm.content.paragraphs,
          "title-class": _vm.content.titleClass,
          "paragraph-class": _vm.content.paragraphClass
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }